import React from 'react';
import { Shield, Mail, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="bg-[#003d82] text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Shield size={64} className="mx-auto mb-6 text-[#f5a623]" />
            <h1 className="text-4xl font-bold mb-4">Política de Privacidade</h1>
            <p className="text-xl text-gray-200">
              A sua privacidade é importante para nós
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-bold text-[#003d82] mb-4">1. Informações que Recolhemos</h2>
              <p className="text-gray-600 mb-6">
                A Litoral Norte recolhe informações pessoais apenas quando fornecidas voluntariamente através dos nossos formulários de contacto e candidatura, incluindo:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-8">
                <li>Nome completo</li>
                <li>Endereço de email</li>
                <li>Número de telefone</li>
                <li>Informações relacionadas com pedidos de orçamento ou candidaturas</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">2. Como Utilizamos as Informações</h2>
              <p className="text-gray-600 mb-6">
                As informações recolhidas são utilizadas exclusivamente para:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-8">
                <li>Responder a pedidos de orçamento e informações</li>
                <li>Processar candidaturas de emprego</li>
                <li>Comunicar sobre os nossos serviços</li>
                <li>Melhorar a experiência do utilizador no nosso site</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">3. Proteção de Dados</h2>
              <p className="text-gray-600 mb-8">
                Comprometemo-nos a proteger as suas informações pessoais e a cumprir o Regulamento Geral de Proteção de Dados (RGPD). Os seus dados são armazenados de forma segura e não são partilhados com terceiros sem o seu consentimento.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">4. Os Seus Direitos</h2>
              <p className="text-gray-600 mb-6">
                De acordo com o RGPD, tem direito a:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-8">
                <li>Aceder aos seus dados pessoais</li>
                <li>Retificar informações incorretas</li>
                <li>Solicitar a eliminação dos seus dados</li>
                <li>Opor-se ao processamento dos seus dados</li>
                <li>Portabilidade dos dados</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">5. Cookies</h2>
              <p className="text-gray-600 mb-8">
                Este site utiliza cookies essenciais para o seu funcionamento. Não utilizamos cookies de rastreamento ou publicidade.
              </p>

              <h2 className="text-2xl font-bold text-[#003d82] mb-4">6. Contactos</h2>
              <p className="text-gray-600 mb-6">
                Para exercer os seus direitos ou esclarecer dúvidas sobre a nossa política de privacidade:
              </p>
              
              <div className="bg-blue-50 border-l-4 border-[#003d82] p-6 rounded-r-lg mb-8">
                <div className="flex items-center gap-3 mb-3">
                  <Mail className="text-[#003d82]" size={20} />
                  <a href={`mailto:${companyInfo.email}`} className="text-[#003d82] font-semibold hover:text-[#f5a623]">
                    {companyInfo.email}
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="text-[#003d82]" size={20} />
                  <a href={`tel:${companyInfo.phone}`} className="text-[#003d82] font-semibold hover:text-[#f5a623]">
                    {companyInfo.phone}
                  </a>
                </div>
              </div>

              <p className="text-sm text-gray-500 mt-8">
                Última atualização: {new Date().toLocaleDateString('pt-PT', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
